// ตำแหน่งทุกอย่างบนกระดาษคำตอบ หน่วยเป็นมิลลิเมตรบน A4 (210 x 297)
//
// ไฟล์นี้เป็นสัญญาระหว่าง "ตัวพิมพ์" กับ "ตัวอ่าน" (ขั้นสแกน) — ทั้งสองต้องเรียกฟังก์ชันเดียวกันนี้
// ห้ามเขียนตัวเลขตำแหน่งซ้ำที่อื่น และห้ามแก้ตัวเลขของแบบที่เคยพิมพ์ไปแล้ว (อาจยังมีแผ่นรอสแกน)
// ถ้าต้องเปลี่ยนแบบกระดาษ ให้เพิ่มแบบใหม่ใน GEOMETRY แล้วขึ้น LAYOUT_VERSION — ของเดิมเก็บไว้ทั้งหมด
//
// ตัวอ่านไม่ต้องรู้ล่วงหน้าว่าแผ่นเป็นแบบไหน: ลองจัดภาพด้วยสี่เหลี่ยมมุมของทุกแบบ (LAYOUT_VERSIONS)
// แบบที่ถอดแถบรหัสผ่าน CRC คือแบบที่ถูก (ดู reader.readSheet) — ตัวเลข "แบบ N" ที่พิมพ์ใต้แถบ
// มีไว้ให้คนอ่านเท่านั้น
//
// ตัวอ่านจัดภาพให้ตรงจากศูนย์กลางสี่เหลี่ยมทึบสี่มุม (markers) แล้วอ่านทุกช่องด้วยพิกัดจากที่นี่
// ตำแหน่งข้อจึงขึ้นกับ "ลำดับของข้อปรนัย" เท่านั้น (ข้ออัตนัยไม่มีช่องฝน) — โครงข้อสอบถูกล็อก
// ทันทีที่มีคำตอบด้วยเหตุผลนี้ (ดู examModel.updateExam)
import { CODE_BITS } from './sheetCode'

export const PAGE = { width: 210, height: 297 }

// ── แบบกระดาษ ────────────────────────────────────────────────────────────────
// แบบ 1: สี่เหลี่ยมมุมห่างขอบกระดาษ 10 มม. ทุกด้าน
// แบบ 2: เผื่อที่เย็บ — ผู้คุมสอบเย็บมุมขวาบน (บางคนมุมซ้ายบน/ขอบซ้าย) แล้วลวดเย็บบังสี่เหลี่ยมมุม
//        แผ่นนั้นจะสแกนไม่ได้เลย สี่เหลี่ยมมุมบนทั้งสองจึงห่างขอบบน 24 มม. และมุมซ้ายห่างขอบซ้าย 24 มม.
//        หัวกระดาษอยู่เหนือแนวสี่เหลี่ยมมุมบน ส่วนที่เหลือเลื่อนลง 4 มม. และขยับเข้าจากซ้าย (คอลัมน์แคบลง)
//        ขอบล่าง/ขวาเท่าเดิม — เลิกพิมพ์แล้ว กลับไปใช้แบบ 1 (ไม่ต้องเผื่อที่เย็บ) แผ่นแบบ 2 ที่พิมพ์ไปแล้วยังสแกนได้
// แบบ 3: ครึ่งแผ่นบน — ประหยัดกระดาษ ครึ่งล่างและด้านหลังให้นักเรียนตอบข้ออัตนัย
//        สี่เหลี่ยมมุมล่างอยู่กลางแผ่น (markerBottom) ช่องฝน 10 แถว ห่างแถวละ 6.2 มม.
//        ตัวเลือกไม่เกิน 4 (ก–ง) ได้ 5 คอลัมน์ = 50 ข้อ, 5 ตัวเลือกได้ 4 คอลัมน์ = 40 ข้อ (narrow)
//        กระดาษสำรอง: คอลัมน์สุดท้ายเป็นช่องฝนเลขประจำตัว ใช้ 10 แถวเดียวกับช่องคำตอบ (เลข 0–9 = แถว 1–10)
//        ช่องเขียนเลขทีละหลัก (ซ้ายไปขวา) อยู่เหนือแถวเลข 0 พอดี ป้าย "ฝนเลขประจำตัว" อยู่ซ้ายของช่องเขียน
//        แถวเดียวกัน (ใต้แถบรหัสไม่มีที่พอให้วางซ้อนกันสองบรรทัด) — ทั้งสองอย่างตัวอ่านไม่ได้อ่าน
//        ตัวพิมพ์เลือกแบบนี้เองเมื่อข้อปรนัยพอ (sheetVersionFor) ครูไม่ต้องเลือก
// แบบ 4 / 5: เหมือนแบบ 1 / 3 ทุกช่องฝน ต่างที่แถบรหัสย้ายไปขอบกระดาษ (edgeCode) — แถวแรก 26 ช่องอยู่ระหว่าง
//        สี่เหลี่ยมมุมบนสองอัน แถวที่สองอยู่ระหว่างสี่เหลี่ยมมุมล่าง และพิมพ์เฉพาะช่องทึบ ไม่มีกรอบของช่องว่าง
//        เพราะแถบกลางแผ่นที่มีช่องสี่เหลี่ยมว่างให้เห็น นักเรียนฝนเล่นจนรหัสพัง (CRC ไม่ผ่าน ครูต้องเลือกคนเอง)
//        ความขาวอ้างอิงของแต่ละช่องวัดที่เส้นกระดาษด้านนอก (ฝั่งขอบกระดาษ) ซึ่งเป็นขอบว่างเสมอ
//        บรรทัดเลขรหัสแผ่น + คำเตือนอยู่ใต้แถวบนทันที (ฝั่งใน — ฝั่งนอกคือเส้นวัดความขาว ห้ามมีอะไร)
//        คำเตือนของแถวล่าง (frame.labelBottom) ชิดขวาตรงปลายแถบ: เต็มหน้าอยู่เหนือแถว (ซ้ายเป็นบรรทัด "ข้อ .. เป็นอัตนัย")
//        ครึ่งแผ่นเหนือแถวไม่มีที่ (ช่องฝนแถวสุดท้ายชิดอยู่) จึงอยู่ใต้แถว เลยเส้นวัดความขาวไป แล้วเลื่อนพื้นที่ตอบอัตนัยลง
//        ข้อความเตือนเลี่ยงสระล่าง (ุ ู) — ตัวอักษรที่ห้อยลงจะไปแตะแถบหรือเส้นวัดความขาว
//        หัวกระดาษเลื่อนลง (frame.head) ให้พ้นบรรทัดนั้น ส่วนข้อความ "ข้อ .. เป็นอัตนัย" ขึ้นไปอยู่เหนือแถวล่าง (frame.note)
// box = ขอบบนของกรอบข้อมูลนักเรียน / codeY0 = แถวบนของแถบรหัส / gridY0 = ศูนย์กลางแถวแรกของช่องฝน
// frame.head = ขอบบนของตราโรงเรียน / frame.label = บรรทัดเลขรหัสแผ่นที่คนอ่าน / frame.note = บรรทัด "ข้อ .. เป็นอัตนัย"
// ค่าที่ไม่ระบุ (columns / rows / rowPitch / markerBottom) ใช้ค่าของแบบเต็มหน้า
const GEOMETRY = {
  1: { markerLeft: 10, markerTop: 10, gridX0: 16, gridY0: 78, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    codeCenterX: PAGE.width / 2, codeY0: 52, frame: { left: 18, right: 192, box: 30 } },
  2: { markerLeft: 24, markerTop: 24, gridX0: 30, gridY0: 82, columnWidth: 41.5, bubbleX0: 12, bubblePitch: 6.2,
    codeCenterX: 113, codeY0: 56, frame: { left: 32, right: 194, box: 34 } },
  3: { markerLeft: 10, markerTop: 10, markerBottom: 133, gridX0: 16, gridY0: 74, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    rows: 10, rowPitch: 6.2, narrow: { maxChoices: 4, columns: 5, columnWidth: 35 },
    id: { dx0: 6, pitch: 6.2, boxY: 64.3, box: 5 },
    codeCenterX: PAGE.width / 2, codeY0: 49, frame: { left: 18, right: 192, box: 28 }, half: true, writtenTop: 143 },
  4: { markerLeft: 10, markerTop: 10, gridX0: 16, gridY0: 78, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    codeCenterX: PAGE.width / 2, edgeCode: true, frame: { left: 18, right: 192, box: 42, head: 21, label: 19.3, labelBottom: 280.3, note: 277.5 } },
  5: { markerLeft: 10, markerTop: 10, markerBottom: 133, gridX0: 16, gridY0: 74, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    rows: 10, rowPitch: 6.2, narrow: { maxChoices: 4, columns: 5, columnWidth: 35 },
    id: { dx0: 6, pitch: 6.2, boxY: 64.3, box: 5 },
    codeCenterX: PAGE.width / 2, edgeCode: true, frame: { left: 18, right: 192, box: 40, head: 21, label: 19.3, labelBottom: 143.8 }, half: true, writtenTop: 146 },
}

export const LAYOUT_VERSION = 4                 // แบบเต็มหน้าที่พิมพ์ตอนนี้ (และกระดาษสำรองทุกแผ่น)
export const HALF_VERSION = 5                   // แบบครึ่งแผ่นที่พิมพ์ตอนนี้
export const LAYOUT_VERSIONS = [4, 5, 1, 3, 2]  // แบบที่ตัวอ่านรู้จัก (ลองตามลำดับนี้)

const geo = (version) => {
  const g = GEOMETRY[version]
  if (!g) throw new Error(`ไม่รู้จักกระดาษคำตอบแบบ ${version}`)
  return g
}

// ตำแหน่งของเนื้อหาที่ไม่ได้ถูกอ่าน (หัวกระดาษ กรอบข้อมูลนักเรียน คำชี้แจง) — ตัวพิมพ์ใช้จัดตำแหน่ง
// { left, right, box: ขอบบนของกรอบข้อมูล, head: ขอบบนของหัวกระดาษ, label: บรรทัดเลขรหัสแผ่น,
//   note: บรรทัดท้ายแผ่น, edge: แถบรหัสอยู่ขอบกระดาษ, grid: แถวแรกของช่องฝน,
//   half: แบบครึ่งแผ่น, written: ขอบบนของพื้นที่ตอบอัตนัย (เฉพาะแบบครึ่งแผ่น) }
export const frameFor = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  return {
    head: 9,
    label: g.codeY0 + 14.5,
    labelBottom: null,
    note: PAGE.height - 12,
    ...g.frame,
    edge: !!g.edgeCode,
    grid: g.gridY0,
    half: !!g.half,
    written: g.writtenTop ?? null,
  }
}

const MARKER = 7
export const markersFor = (version = LAYOUT_VERSION) => {
  const { markerLeft: left, markerTop: top, markerBottom } = geo(version)
  const right = PAGE.width - 10 - MARKER
  const bottom = markerBottom ?? PAGE.height - 10 - MARKER
  return [
    { corner: 'tl', x: left, y: top, size: MARKER },
    { corner: 'tr', x: right, y: top, size: MARKER },
    { corner: 'bl', x: left, y: bottom, size: MARKER },
    { corner: 'br', x: right, y: bottom, size: MARKER },
  ]
}
export const MARKERS = markersFor(LAYOUT_VERSION)

// แถบรหัสแผ่น 2 แถว แถวละ 26 ช่อง (ทุกแบบใช้ช่องขนาดเดียวกัน ต่างแค่ตำแหน่ง)
const CODE_PER_ROW = CODE_BITS / 2
const CODE_CELL = 4
const CODE_PITCH = 5.5

// ตารางช่องฝนของแบบเต็มหน้า 4 คอลัมน์ x 25 ข้อ (แบบครึ่งแผ่นดู grid() / capacityOf)
export const COLUMNS = 4
export const ROWS_PER_COLUMN = 25
export const MAX_BUBBLE_QUESTIONS = COLUMNS * ROWS_PER_COLUMN
const ROW_PITCH = 8
const BUBBLE_R = 2.4

// คอลัมน์/แถวของตารางช่องฝนตามแบบและจำนวนตัวเลือก — แบบครึ่งแผ่นใส่ได้ 5 คอลัมน์เมื่อตัวเลือกไม่เกิน 4
const grid = (g, choices) => {
  const narrow = g.narrow && Number(choices) <= g.narrow.maxChoices ? g.narrow : null
  return {
    columns: narrow?.columns ?? g.columns ?? COLUMNS,
    columnWidth: narrow?.columnWidth ?? g.columnWidth,
    rows: g.rows ?? ROWS_PER_COLUMN,
    rowPitch: g.rowPitch ?? ROW_PITCH,
  }
}

// จำนวนข้อปรนัยสูงสุดที่แบบนั้นรับได้ (กระดาษสำรองเสียหนึ่งคอลัมน์ให้ช่องฝนเลขประจำตัว)
export const capacityOf = (version, choices, spare = false) => {
  const { columns, rows } = grid(geo(version), choices)
  return (spare ? columns - 1 : columns) * rows
}

// แบบที่จะพิมพ์: ข้อปรนัยพอครึ่งแผ่นก็พิมพ์ครึ่งแผ่น ไม่พอพิมพ์เต็มหน้า — กระดาษสำรองคิดแยก (รับได้น้อยกว่าหนึ่งคอลัมน์)
// ข้อสอบชุดเดียวกันจึงได้แผ่นปกติครึ่งแผ่นแต่แผ่นสำรองเต็มหน้าได้ ตัวอ่านแยกแบบจากแถบรหัสอยู่แล้ว
export const objectiveCount = (questions) => questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse').length
export const sheetVersionFor = (questions, choices, spare = false) => (
  objectiveCount(questions) <= capacityOf(HALF_VERSION, choices, spare) ? HALF_VERSION : LAYOUT_VERSION
)

// ---- กระดาษสำรอง: ช่องฝนเลขประจำตัวอยู่ในคอลัมน์ที่ 4 ของตารางคำตอบ ----
// ข้อ 1-75 อยู่ตำแหน่งเดิมทุกข้อ ตัวอ่านใช้ bubbleLayout ตัวเดียวกันได้ กระดาษสำรองจึงรับข้อปรนัย
// ได้ 3 คอลัมน์ ส่วนคอลัมน์ที่ 4 เป็นช่องเขียน + ช่องฝนเลข 5 หลัก (เลขประจำตัวนักเรียนเกือบทั้งหมด
// เป็นตัวเลข 5 หลัก — คนที่ไม่ใช่ ครูเลือกนักเรียนเองตอนสแกน)
export const ID_DIGITS = 5
export const SPARE_MAX_OBJECTIVE = (COLUMNS - 1) * ROWS_PER_COLUMN
// ระยะนับจากแถวแรกของตาราง (gridY0 ของแบบนั้น)
const ID_TITLE_DY = 0                       // บรรทัดหัว "เลขประจำตัว"
const ID_BOX_DY = 3                         // ช่องเขียนเลขด้วยมือ (ให้ครูเทียบกับที่ฝน)
const ID_BOX = 5.4
const ID_DY0 = 14                           // ศูนย์กลางแถวเลข 0
const ID_PITCH = 7

// คืน { titleX, titleY, titleAnchor, boxes: [{x, y, size}], digits: [{ index, bubbles: [{ value, label, cx, cy, r }] }] }
// choices มีผลเฉพาะแบบครึ่งแผ่น (จำนวนคอลัมน์ขึ้นกับจำนวนตัวเลือก)
export const idLayout = (version = LAYOUT_VERSION, choices = 5) => {
  const g = geo(version)
  const { columns, columnWidth, rowPitch } = grid(g, choices)
  const colX = g.gridX0 + (columns - 1) * columnWidth
  if (g.id) {
    // แบบครึ่งแผ่น: เลข 0–9 วางตรงแถวคำตอบ 1–10 ช่องเขียนเลขอยู่เหนือแถวเลข 0
    // แบบ 5: ป้ายอยู่เหนือช่องเขียน (ทางซ้ายชนบรรทัดคำชี้แจงที่อยู่แถวเดียวกัน)
    // แบบ 3: เหนือช่องเขียนเป็นแถบรหัสกลางแผ่น ป้ายจึงอยู่ซ้ายของช่องเขียนเหมือนเดิม
    const digits = Array.from({ length: ID_DIGITS }, (_, d) => {
      const cx = colX + g.id.dx0 + d * g.id.pitch
      return {
        index: d,
        cx,
        bubbles: Array.from({ length: 10 }, (_, v) => ({
          value: String(v), label: String(v), cx, cy: g.gridY0 + v * rowPitch, r: BUBBLE_R,
        })),
      }
    })
    const { boxY, box } = g.id
    const title = g.edgeCode
      ? { titleX: (digits[0].cx + digits[ID_DIGITS - 1].cx) / 2, titleY: boxY - 1.3, titleAnchor: 'middle' }
      : { titleX: digits[0].cx - box / 2 - 1.5, titleY: boxY + box - 1, titleAnchor: 'end' }
    return {
      ...title,
      boxes: digits.map((d) => ({ x: d.cx - box / 2, y: boxY, size: box })),
      digits,
    }
  }
  const digits = Array.from({ length: ID_DIGITS }, (_, d) => {
    const cx = colX + g.bubbleX0 + d * g.bubblePitch
    return {
      index: d,
      cx,
      bubbles: Array.from({ length: 10 }, (_, v) => ({
        value: String(v), label: String(v), cx, cy: g.gridY0 + ID_DY0 + v * ID_PITCH, r: BUBBLE_R,
      })),
    }
  })
  return {
    titleX: colX + 5,
    titleY: g.gridY0 + ID_TITLE_DY,
    titleAnchor: 'start',
    boxes: digits.map((d) => ({ x: d.cx - ID_BOX / 2, y: g.gridY0 + ID_BOX_DY, size: ID_BOX })),
    digits,
  }
}

const CHOICE_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ']
const TF_OPTIONS = [{ value: 'T', label: 'ถ' }, { value: 'F', label: 'ผ' }]

// คืน [{ index, x, y, size, wy }] — wy = เส้นกระดาษว่างที่ตัวอ่านใช้วัดความขาวของช่องนั้น (ตรงคอลัมน์เดียวกัน)
//   แถบกลางแผ่น (แบบ 1–3): เส้นระหว่างสองแถวของแถบ
//   แถบขอบกระดาษ (แบบ 4–5): แถวบนอยู่แนวเดียวกับสี่เหลี่ยมมุมบน แถวล่างแนวเดียวกับมุมล่าง วัดขาวด้านนอก (ขอบว่าง)
const CODE_WHITE_GAP = 1.25
export const codeCells = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  const x0 = g.codeCenterX - ((CODE_PER_ROW - 1) * CODE_PITCH + CODE_CELL) / 2
  const rowY = g.edgeCode
    ? markersFor(version)
      .filter((m) => m.corner.endsWith('l'))
      .sort((a, b) => a.y - b.y)
      .map((m) => m.y + (m.size - CODE_CELL) / 2)
    : [g.codeY0, g.codeY0 + CODE_PITCH]
  const middle = (g.codeY0 + CODE_CELL + g.codeY0 + CODE_PITCH) / 2
  return Array.from({ length: CODE_BITS }, (_, i) => {
    const row = Math.floor(i / CODE_PER_ROW)
    const y = rowY[row]
    return {
      index: i,
      x: x0 + (i % CODE_PER_ROW) * CODE_PITCH,
      y,
      size: CODE_CELL,
      wy: !g.edgeCode ? middle : row === 0 ? y - CODE_WHITE_GAP : y + CODE_CELL + CODE_WHITE_GAP,
    }
  })
}

// questions = [{ eq_no, eq_type }] เรียงตาม eq_no — คืนตำแหน่งเลขข้อและช่องฝนของข้อปรนัย
// spare = กระดาษสำรอง (คอลัมน์ที่ 4 เป็นช่องฝนเลขประจำตัว) — ตำแหน่งข้อเหมือนกระดาษปกติทุกข้อ ต่างแค่เพดาน
export const bubbleLayout = (questions, choices, spare = false, version = LAYOUT_VERSION) => {
  const g = geo(version)
  const objective = questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse')
  const { columnWidth, rows, rowPitch } = grid(g, choices)
  const max = capacityOf(version, choices)
  if (objective.length > max) {
    throw new Error(`กระดาษ${g.half ? 'ครึ่งแผ่น' : 'หนึ่งแผ่น'}รับข้อปรนัยได้ไม่เกิน ${max} ข้อ`)
  }
  if (spare && objective.length > capacityOf(version, choices, true)) {
    throw new Error(`กระดาษสำรองรับข้อปรนัยได้ไม่เกิน ${capacityOf(version, choices, true)} ข้อ (คอลัมน์สุดท้ายเป็นช่องฝนเลขประจำตัว)`)
  }
  return objective.map((q, i) => {
    const colX = g.gridX0 + Math.floor(i / rows) * columnWidth
    const cy = g.gridY0 + (i % rows) * rowPitch
    const options = q.eq_type === 'truefalse'
      ? TF_OPTIONS
      : CHOICE_LABELS.slice(0, choices).map((label, k) => ({ value: String(k + 1), label }))
    return {
      eq_no: q.eq_no,
      eq_type: q.eq_type,
      numberX: colX + 8,
      cy,
      bubbles: options.map((o, k) => ({
        value: o.value,
        label: o.label,
        cx: colX + g.bubbleX0 + k * g.bubblePitch,
        cy,
        r: BUBBLE_R,
      })),
    }
  })
}
